import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface ShowOptions {
    showHeader: boolean;
    showFooter: boolean;
    showToolBar: boolean;
    showHelp: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class AppVisibilityService {
    private showOptionsSubject = new BehaviorSubject<ShowOptions>({
        showHeader: false,
        showFooter: false,
        showToolBar: false,
        showHelp: false,
    });

    showOptions$ = this.showOptionsSubject.asObservable();

    setOptions(header: boolean, footer: boolean, toolBar: boolean, help) {
        this.showOptionsSubject.next({
            showHeader: header,
            showFooter: footer,
            showToolBar: toolBar,
            showHelp: help,
        });
    }
}
